import * as React from "react";
import Category from "../line/details/Category";

function isSameCategory(first, second) {
    if (!first || !second) {
        return false;
    }

    return first.category.id === second.category.id
}

const columns = (t) => [

    {
        label: t ? t("common.name") : "Nazwa",
        field: "name",
        width: 53,
        type: "custom",
        custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState, externalState2, setExternalState) {
            const category = {category:row}

            return        <Category categoryItem={category}
                                    withoutPadding={true}
                                    active={isSameCategory(externalState, category)}
                                    onClick={() => {
                                        if (isSameCategory(externalState, category)) {
                                            setExternalState(undefined)
                                        } else {
                                            setExternalState(category)
                                        }
                                    }}
            />
        }
    },

]

export default columns;